<template>
	<div class="c-background-select">
		<div
			v-for="background in backgrounds"
			:key="background.name"
			class="c-background-select__item"
		>
			<div
				class="cover"
				tabindex="0"
				@click="onSelect(background.value)"
				:style="'background-image:url(' + background.url + ')'"
			>
				<span class="badge" v-if="currentBackground === background.value">
					<check-icon size="1.5x" class="custom-class"></check-icon>
				</span>
			</div>
			<p v-html="background.description"></p>
		</div>
	</div>
</template>

<script>
import { PlusIcon, CheckIcon } from 'vue-feather-icons';
import backgrounds from '@/lib/backgrounds.js';
export default {
	components: {
		PlusIcon,
		CheckIcon,
	},
	data: function () {
		var obj = {
			currentBackground: 'none',
			currentBucket: null,
			backgrounds: backgrounds,
		};
		return obj;
	},
	props: ['background'],
	watch: {
		background: {
			handler: function () {
				this.$store.dispatch('event/trackEvent', {
					name: 'Wallpaper : Changed',
					data: {
						type: this.background || 'None',
					},
				});
				if (this.background) {
					this.currentBackground = this.background;
				}
			},
			immediate: true,
		},
	},
	computed: {
		selectedText: function () {
			var str = 'Select a bucket';
			if (this.currentBucket) {
				str = this.getTitle(this.currentBucket.title, true);
			}
			return str;
		},
	},
	methods: {
		onSelect: function (background) {
			this.currentBackground = background;
			this.$emit('change', this.currentBackground);
		},
		removeBucket: function () {
			this.currentBucket = '';
			this.$emit('change', null);
		},
	},
};
</script>

<style lang="scss">
.c-background-select {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	//grid-template-rows: 1fr 1fr;
	grid-column-gap: var(--spacer-sm);
	grid-row-gap: var(--spacer-sm);
	justify-items: stretch;
	align-items: stretch;

	&__item {
		padding-bottom: 10px;
		font-size: var(--font-size-sm);

		p {
			margin-bottom: 0;
		}
	}

	.cover {
		position: relative;
		width: 100%;
		height: 100px;
		border-radius: var(--border-radius);
		background-color: var(--p4);
		background-color: #000;
		background-size: cover;
		margin-bottom: 4px;
		cursor: pointer;

		&:after {
			@include overlay(rgba(0, 0, 0, 0.3));
			mix-blend-mode: hue;
		}

		&:focus {
			outline: none;
			box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3), 0 1px 8px 0 rgba(0, 0, 0, 0.2),
				0 0 0 4px rgba($primary, 0.6) !important;
		}
	}

	.badge {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 4px;
		position: absolute;
		top: 8px;
		right: 8px;
		background-color: var(--success);
		color: #fff;
		border-radius: 50%;
	}
}
</style>
